import { render, staticRenderFns } from "./DeferralAttachment.vue?vue&type=template&id=093ea5aa&scoped=true"
import script from "./DeferralAttachment.vue?vue&type=script&lang=js"
export * from "./DeferralAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093ea5aa",
  null
  
)

export default component.exports